
export const LOGIN_LOGO = "/../../../assets/images/logo.svg"
export const SIDEBAR_LOGO = "/../../../../assets/img/login_logo.png"
export const PROFILE_IMG = "/../../../assets/img/avatar/avatar-4.png"
export const DUMMY_IMG = "/../../../assets/img/avatar/avatar-4.png"
export const PRODUCT_IMG = "../../../assets/images/img-icon/dummy.png"
export const MAIN_LOGO = "/../../../assets/images/logo.png"
export const MAIN_LOGO_DUMMY = "/../../../assets/images/faces-clipart/pic-3.png"
export const MAIN_LOGO_DUMMY_ = "/../../../assets/images/logo.png"
export const MAIN_DUMMY_ = "/../../../assets/images/img-icon/dummy.png"
export const MAIN__DUMMY_ = "/../../../assets/images/img-icon/icon.jpg"
